import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RecipientMaintenanceComponent } from './recipient-maintenance.component';

const routes: Routes = [
  {
    path:'',
    component: RecipientMaintenanceComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RecipientMaintenanceRoutingModule { }
